import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { App, Spin, theme } from 'antd'
import { universalGetUserInfo } from '@/server/login'
import { getAllPermissions } from '@/server/home.js'

function AvoidLogin () {
  const {
    token: { colorBgLayout, colorText, colorPrimary },
  } = theme.useToken(); //获取主题颜色
  const { message } = App.useApp();

  const navigate = useNavigate();
  const location = useLocation();
  const [tips, setTips] = useState('加载中');//提示
  const [showLoading, setShowLoading] = useState(true);

  //获取用户信息 及 权限
  const getUserInfoFun = async (token) => {
    // 获取当前账号角色，并展示不同的菜单
    const res = await universalGetUserInfo({
      access_token: token,
    });
    localStorage.setItem('dock_memberLevel', res.data.profile.member_level)

    //获取权限
    let res2 = await getAllPermissions({
      access_token: token,
      member_level: res.data.profile.member_level
    })
    if (res2.ret !== 200) {
      message.warning(res2.msg || '数据跑丢了~');
      return
    }
    if (res2.data.menu && res2.data.menu.length) {
      window.localStorage.setItem('dock_AirportPermissionsArr', JSON.stringify(res2.data.menuids));
      window.localStorage.setItem('dock_AirportPermissionsArrName', JSON.stringify(res2.data.menuName));
    } else {
      window.localStorage.setItem('dock_AirportPermissionsArr', '');
      window.localStorage.setItem('dock_AirportPermissionsArrName', '');
    }
    setTimeout(() => {
      navigate('/ShippingLineRoutine');
    }, 500)
  }

  useEffect(() => {
    localStorage.clear();
    if (location.search) { //免登进去系统
      let token = location.search.split('=')[1];
      localStorage.setItem('dock_isLogin', true);
      localStorage.setItem('dock_token', token);
      localStorage.setItem('dock_isAvoidLogin', 1);//是否为免密登录
      getUserInfoFun(token);
    }
    else {//没有token
      setTimeout(() => {
        setTips('加载失败，没有密钥');
        setShowLoading(false);
      }, 1000)

    }
    // eslint-disable-next-line
  }, [])

  return (
    <div className='box border'
      style={{ height: '100vh', width: '100vw', background: colorBgLayout, color: colorText }}>
      <div className='wid100 hei100 flex_col justify_center  align_center'>
        <div className='fs32 fw600 marB12'>
          管理系统-本地化部署
        </div>
        <div className='flex_row justify_center align_center'>
          <div className='fs24 fw600 marR12'>{tips}</div>
          <span style={{ display: showLoading ? '' : 'none' }}>
            <Spin size="large" />
          </span>
          <span className='pointer' onClick={() => { navigate('/login'); }}
            style={{ display: !showLoading ? '' : 'none', color: colorPrimary }}>
            登录
          </span>
        </div>

      </div>
    </div>
  )

}
export default AvoidLogin
